(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const selectors = [
    '.lap-gallery-track .lap-media-item--image .lap-media-frame > img',
    'media-gallery .product__media-item:not(.hidden) .product__modal-opener--image img',
    '.lohnr-duos__item-photo img'
  ].join(', ');
  let dialog, stage, image, counter, previous, next, source, gallery, images = [], index = 0;
  let scale = 1, offsetX = 0, offsetY = 0, start = null, lastTap = 0;
  let gestureMoved = false, suppressClickUntil = 0;

  function highResolution(img) {
    const candidates = (img.getAttribute('srcset') || '').split(',').map((part) => {
      const match = part.trim().match(/^(\S+)\s+(\d+)w$/);
      return match ? { url: match[1], width: Number(match[2]) } : null;
    }).filter(Boolean).sort((a, b) => b.width - a.width);
    return candidates.length ? candidates[0].url : img.currentSrc || img.src;
  }

  function makeDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'lohnr-mobile-zoom';
    dialog.setAttribute('aria-label', 'Product image gallery');
    dialog.innerHTML = '<div class="lohnr-mobile-zoom__bar"><span data-zoom-count></span><button type="button" data-zoom-close aria-label="Close image gallery">×</button></div><div class="lohnr-mobile-zoom__stage" data-zoom-stage><img class="lohnr-mobile-zoom__image" data-zoom-image alt="" draggable="false"></div><div class="lohnr-mobile-zoom__controls"><button type="button" data-zoom-prev aria-label="Previous image">‹</button><span class="lohnr-mobile-zoom__hint">Pinch to zoom</span><button type="button" data-zoom-next aria-label="Next image">›</button></div>';
    document.body.appendChild(dialog);
    stage = dialog.querySelector('[data-zoom-stage]');
    image = dialog.querySelector('[data-zoom-image]');
    counter = dialog.querySelector('[data-zoom-count]');
    previous = dialog.querySelector('[data-zoom-prev]');
    next = dialog.querySelector('[data-zoom-next]');
    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = dialog.dataset.previousOverflow || '';
      image.removeAttribute('src');
      if (source && source.isConnected) source.focus({ preventScroll: true });
      source = null;
    });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); dialog.close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' && scale === 1) show(index + 1);
      if (event.key === 'ArrowLeft' && scale === 1) show(index - 1);
    });
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd, { passive: false });
    stage.addEventListener('dblclick', (event) => { event.preventDefault(); setScale(scale > 1 ? 1 : 2.5); });
    stage.addEventListener('click', (event) => {
      const now = Date.now();
      if (now - lastTap < 300) { event.preventDefault(); setScale(scale > 1 ? 1 : 2.5); }
      lastTap = now;
    });
    mobile.addEventListener('change', () => { if (!mobile.matches && dialog.open) dialog.close(); });
  }

  function render() {
    const maxX = Math.max(0, (stage.clientWidth * scale - stage.clientWidth) / 2);
    const maxY = Math.max(0, (stage.clientHeight * scale - stage.clientHeight) / 2);
    offsetX = Math.max(-maxX, Math.min(maxX, offsetX));
    offsetY = Math.max(-maxY, Math.min(maxY, offsetY));
    image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
  }

  function setScale(value) {
    scale = Math.max(1, Math.min(4, value));
    if (scale === 1) offsetX = offsetY = 0;
    render();
  }

  function show(position) {
    if (position < 0 || position >= images.length) return;
    index = position;
    setScale(1);
    image.src = highResolution(images[index]);
    image.alt = images[index].alt || 'Product image';
    counter.textContent = `${index + 1} / ${images.length}`;
    previous.disabled = index === 0;
    next.disabled = index === images.length - 1;
  }

  function containerFor(img) {
    return img.closest('.lap-gallery-track') || img.closest('media-gallery') || img.closest('.lohnr-duos__choices');
  }

  function open(img, pinch) {
    if (!mobile.matches || !img) return;
    makeDialog();
    gallery = containerFor(img);
    images = gallery ? Array.from(gallery.querySelectorAll(selectors)).filter((candidate) => candidate.closest('.hidden, [hidden]') === null && candidate.getClientRects().length) : [img];
    if (!images.includes(img)) images = [img];
    source = img;
    const position = images.indexOf(img);
    if (!dialog.open) {
      dialog.dataset.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      try { dialog.showModal(); } catch (_) { document.documentElement.style.overflow = dialog.dataset.previousOverflow; return; }
    }
    show(position);
    if (pinch) setScale(2);
    dialog.querySelector('[data-zoom-close]').focus({ preventScroll: true });
  }

  function distance(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function onTouchStart(event) {
    if (event.touches.length === 2) {
      start = { type: 'pinch', distance: distance(event.touches[0], event.touches[1]), scale };
      event.preventDefault();
    } else if (event.touches.length === 1) {
      start = { type: 'one', x: event.touches[0].clientX, y: event.touches[0].clientY, offsetX, offsetY };
      gestureMoved = false;
    }
  }
  function onTouchMove(event) {
    if (!start) return;
    event.preventDefault();
    if (event.touches.length === 2) {
      if (start.type !== 'pinch') start = { type: 'pinch', distance: distance(event.touches[0], event.touches[1]), scale };
      setScale(start.scale * distance(event.touches[0], event.touches[1]) / Math.max(1, start.distance));
      gestureMoved = true;
    } else if (event.touches.length === 1 && start.type === 'one') {
      const dx = event.touches[0].clientX - start.x, dy = event.touches[0].clientY - start.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) gestureMoved = true;
      if (scale > 1) { offsetX = start.offsetX + dx; offsetY = start.offsetY + dy; render(); }
    }
  }
  function onTouchEnd(event) {
    if (!start) return;
    if (event.touches.length) { start = null; return; }
    if (start.type === 'one' && scale === 1) {
      const dx = event.changedTouches[0].clientX - start.x;
      if (Math.abs(dx) > 55) show(index + (dx < 0 ? 1 : -1));
    }
    start = null;
  }

  document.addEventListener('touchstart', (event) => {
    if (!mobile.matches || event.touches.length < 2 || dialog && dialog.open) return;
    const img = event.target.closest && event.target.closest(selectors);
    if (img) { event.preventDefault(); suppressClickUntil = Date.now() + 500; open(img, true); }
  }, { capture: true, passive: false });
  document.addEventListener('touchmove', (event) => {
    if (event.touches.length === 1 && event.target.closest && event.target.closest(selectors)) gestureMoved = true;
  }, { capture: true, passive: true });
  document.addEventListener('touchend', (event) => {
    if (event.target.closest && event.target.closest(selectors) && gestureMoved) suppressClickUntil = Date.now() + 400;
  }, { capture: true, passive: true });
  document.addEventListener('click', (event) => {
    if (!mobile.matches || dialog && dialog.open) return;
    const img = event.target.closest && event.target.closest(selectors);
    if (!img) return;
    if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); gestureMoved = false; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    gestureMoved = false;
    open(img, false);
  }, true);
})();
